<template>
    <div class="wehcat-menu" v-loading="loadingFlag">
        <el-row :gutter="2">
            <el-col :span="5">
                <div class="left">
                    <div class="add-btn flex-between">
                        <el-button type="primary" size="small" @click="changeMenu('add')">新增菜单</el-button>
                        <span style=" max-width: 120px;">
                            <el-select v-model="tagId" size="small" placeholder="请选择角色" @change="selectChange" clearable >
                                <el-option
                                        v-for="item in tagArr"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                              </el-select>
                        </span>
                    </div>
                    <template v-if="tagId != '66'">
                        <div class="radio-group">
                            <p>中文菜单 </p>
                            <el-radio-group v-model="radioValue" @change="initTableData" >
                                <template v-for="(item,index) in menuData" v-if="item.rule.tagId === tagId && item.rule.language=='zh_CN'">
                                    <template v-for="(btnItem, btnIndex) in item.buttons">
                                        <div class="radio-control flex-between" >
                                            <el-radio :label="btnItem.radioIndex">{{btnItem.name}}</el-radio>
                                            <div class="btn-group">
                                                <el-button type="text" size="mini" @click="changeMenu('edit',index,btnIndex)">编辑
                                                </el-button>
                                                <el-button type="text" style="color: #f00" size="mini"
                                                           @click="delMenu(index, btnIndex)">
                                                    删除
                                                </el-button>
                                            </div>
                                        </div>
                                    </template>
                                </template>
                            </el-radio-group>
                        </div>
                        <div class="radio-group">
                            <p>英文菜单 </p>
                            <el-radio-group v-model="radioValue" >
                                <template v-for="(item,index) in menuData" v-if="item.rule.tagId === tagId && item.rule.language=='en'">
                                    <template v-for="(btnItem, btnIndex) in item.buttons">
                                        <div class="radio-control flex-between" >
                                            <el-radio :label="btnItem.radioIndex">{{btnItem.name}}</el-radio>
                                            <div class="btn-group">
                                                <el-button type="text" size="mini" @click="changeMenu('edit',index,btnIndex)">编辑
                                                </el-button>
                                                <el-button type="text" style="color: #f00" size="mini"
                                                           @click="delMenu(index,btnIndex)">
                                                    删除
                                                </el-button>
                                            </div>
                                        </div>
                                    </template>
                                </template>
                            </el-radio-group>
                        </div>
                    </template>

                    <template v-else>
                        <div class="radio-group">
                            <p>默认菜单</p>
                            <el-radio-group v-model="radioValue" >
                                <template v-for="(item,index) in menuData" v-if="item.rule.tagId === tagId ">
                                    <template v-for="(btnItem, btnIndex) in item.buttons">
                                        <div class="radio-control flex-between" >
                                            <el-radio :label="btnItem.radioIndex">{{btnItem.name}}</el-radio>
                                            <div class="btn-group">
                                                <el-button type="text" size="mini" @click="changeMenu('edit',index,btnIndex)">编辑
                                                </el-button>
                                                <el-button type="text" style="color: #f00" size="mini"
                                                           @click="delMenu(index,btnIndex)">
                                                    删除
                                                </el-button>
                                            </div>
                                        </div>
                                    </template>
                                </template>
                            </el-radio-group>
                        </div>
                    </template>

                </div>
            </el-col>
            <el-col :span="19">
                <div class="right">
                    <div class="add-btn add-child">
                        <el-button type="primary" size="small" @click="changeMenu('add-child')">新增子菜单</el-button>
                    </div>
                    <el-table
                            :data="menuChildData"
                            border
                            style="width: 100%">
                        <el-table-column
                                prop="sort"
                                label="排序"
                                >
                        </el-table-column>
                        <el-table-column
                                prop="name"
                                label="菜单名称"
                                >
                        </el-table-column>
                        <el-table-column
                                prop="content"
                                label="菜单内容"
                                >
                        </el-table-column>
                        <el-table-column
                                label="操作"
                                width="100">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click="editChild(scope.row)">编辑</el-button>
                                <el-button type="text" size="small" @click="editChild(scope.row, 'del')">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-col>
        </el-row>

        <el-dialog
                :title="dialogTitle"
                :visible.sync="createMenuShow"
                width="60%"
                v-loading="loadingFlag"
        >
            <el-form ref="form" :model="form" label-width="100px" size="mini">
<!--                <el-form-item label="排序" >-->
<!--                    <el-select v-model="form.sort" placeholder="请选择排序">-->
<!--                        <el-option label="1" value="1"></el-option>-->
<!--                        <el-option label="2" value="2"></el-option>-->
<!--                        <el-option label="3" value="3"></el-option>-->
<!--                    </el-select>-->
<!--                </el-form-item>-->
                <el-form-item label="语言">
                    <el-switch
                            v-model="isEn"
                            :disabled="dialogType !== 'add' && tagId === '66'"
                            size="mini"
                            active-color="#409eff"
                            inactive-color="#13ce66"
                            active-text="英文"
                            inactive-text="中文">
                    </el-switch>
                </el-form-item>
                <el-form-item label="菜单名称">
                    <el-input v-model="form.menuName" placeholder="请输入菜单名称"></el-input>
                </el-form-item>

                <el-form-item label="菜单内容">
                    <el-radio-group v-model="form.menuType">
                        <el-radio :label="1">发送消息</el-radio>
                        <el-radio :label="2">跳转网页</el-radio>
                        <el-radio :label="3">跳转小程序</el-radio>
                    </el-radio-group>
                </el-form-item>
                <template v-if="form.menuType == 1">
                    <el-form-item label="消息类型" class="form-tabs">
                        <el-tabs v-model="activeName" >
                            <el-tab-pane label="文本内容" name="text"></el-tab-pane>
                            <el-tab-pane label="图片" name="image"></el-tab-pane>
                            <el-tab-pane label="视频" name="video"></el-tab-pane>
                            <el-tab-pane label="音频" name="voice"></el-tab-pane>
                            <el-tab-pane label="图文" name="news"></el-tab-pane>
                        </el-tabs>
                        <div v-if="activeName === 'text'">
                            <el-input type="textarea" :rows="4" v-model="form.sendText" :placeholder="$lange == 'en' ? 'Please enter send context' : '请输入发送文本'"></el-input>
                        </div>
                        <div v-else>
                            <cc-table :config="mediaTableConfig"
                                      :data-arr="mediaTableData"
                                      :load-data="false"
                                      v-loading="mediaTableLoading"
                            ></cc-table>
                        </div>
                    </el-form-item>
                </template>

                <template v-if="form.menuType == 2">
                    <el-form-item label="网页链接">
                        <el-input v-model="form.sendMsg" placeholder="请输入网页链接"></el-input>
                    </el-form-item>
                </template>

                <template v-if="form.menuType == 3">
                    <el-form-item label="小程序链接">
                        <el-select v-model="form.sendMsg" placeholder="请选择要跳转的小程序">
                            <el-option
                                    v-for="item in appletUrl"
                                    :label="item.name"
                                    :value="item.url"
                            ></el-option>
                        </el-select>
<!--                        <el-input v-model="form.sendMsg" placeholder="请输入小程序链接"></el-input>-->
                    </el-form-item>
                </template>
            </el-form>
            <div class="save flex-between">
                <el-button type="primary" size="mini" @click="save">保存</el-button>
            </div>

        </el-dialog>

    </div>
</template>

<script>

    export default {
        name: "WechatMenu",
        data() {
            return {
                mediaTableLoading: false,
                mediaTableData: [],
                rowData: {},
                mediaTableConfig: {
                    // showPager: true,
                    radioValue: 0,
                    columns: [
                        {
                            lable: "选择",
                            type: "radio"
                        },
                        {
                            lable: this.$lange == 'en' ?  'Name' : '名称',
                            render: row => {
                                let res = row.name;
                                if(this.activeName === 'news' && row.content.articles !== undefined){
                                    res = row.content.articles[0].title;
                                }
                                return res;
                            }
                        },
                    ],

                }, //配件的表格
                activeName: "text",
                tabArr: [
                    "text",
                    "image",
                    "video",
                    "voice",
                    "news",
                ],
                loadingFlag: true,
                isEn: false,
                tagId: '66',
                tagArr: [
                    {
                        label: "默认",
                        value: "66"
                    }, {
                        label: "项目经理",
                        value: "100"
                    },
                    {
                        label: "工程师",
                        value: "101"
                    },
                    {
                        label: "班长",
                        value: "103"
                    },
                    {
                        label: "员工",
                        value: "102"
                    },
                ],
                radioValue: 0,
                menuData: [],
                createMenuShow: false,
                dialogType: "add",
                dialogTitle: "新增菜单",
                parentIndex: false,
                parentBtnIndex: false,
                childIndex: false,
                rowId: false,
                showMediaId: false,
                menuChildData: [],
                appletUrl: [
                    { url: "/pages/index/index", name: "首页" }, //首页
                    { url: "/pages/index/index?type=workPlan", name: "工作计划"}, //工作计划
                    { url: "/pages/index/index?type=workReport", name: "车间日报"}, //车间日报
                    { url: "/pages/index/index?type=project", name: "安装任务"}, //安装任务 等同于 项目列表
                    { url: "/pages/index/index?type=afterSaleReport", name: "外派日报"}, //外派日报
                    { url: "/pages/index/index?type=afterSaleList", name: "外派任务"}, //外派任务
                    { url: "/pages/index/index?type=preForm", name: "售前咨询"}, //售前咨询
                    { url: "/pages/index/index?type=preSale", name: "售前产品展示"}, //售前产品展示
                    { url: "/pages/index/index?type=staff", name: "员工认证"}, //员工认证
                    { url: "/pages/index/index?type=customer", name: "客户认证"}, //客户认证
                ],
                form: {
                    // sort: 1,
                    menuName: '',
                    menuType: 1,
                    sendMsg: '',
                    sendText: "",
                    mediaId: "",
                }
            }
        },
        watch: {
          radioValue: {
              handler(){
                  this.initTableData();
              }
          },
            activeName: {
                handler(newData,lastData){
                    let data = {
                        type: newData,
                        offset:"0",
                        count:"10"
                    };
                    this.ccRequest.do("wechat/mp/fosberMp/material/materialBatchGet", data, "POSTJSON").then(res => {
                        this.mediaTableData = res.items;
                        for(let i in res.items){
                            if(this.showMediaId == res.items[i].mediaId){
                                this.mediaTableConfig.radioValue = i*1;
                                console.log(i, "iiiiiiiiiiiiiiii");
                            }
                        }
                    })
                }
            }
        },
        methods: {
            tabChange(res){
                if(res.name !== 'text'){
                    this.mediaTableLoading = true;
                    let data = {
                        type: res.name,
                        offset:"0",
                        count:"10"
                    };
                    this.ccRequest.do("wechat/mp/fosberMp/material/materialBatchGet", data, "POSTJSON").then(res => {
                        this.mediaTableData = res.items;
                        this.mediaTableLoading = false;
                        console.log(res)
                    })
                }
            },
            selectChange(){
                this.radioValue = "";
                this.initTableData();
            },
            editChild(row,type = false){
                if(type == 'del'){
                    for(let i in this.menuData){
                        if(this.menuData[i].rule.tagId === this.tagId){
                            for(let j in this.menuData[i].buttons){
                                if(this.menuData[i].buttons[j].radioIndex === this.radioValue){
                                    this.parentBtnIndex = j;
                                    this.childIndex = row.sort-1;
                                    this.delMenu(i,j, true)
                                }
                            }
                        }
                    }

                } else {
                    this.childIndex = row.sort-1;
                    this.changeMenu("edit-child")
                }

            },
            getMenu() {
                console.log("this.ccRequest")
                this.ccRequest.do("wechat/mp/fosberMp/menu/get", {}, "GET").then(res => {
                    res.menu.rule = {
                        tagId: "66",

                    }
                    res.conditionalMenu.push(res.menu);
                    let num = 0;
                    for(let i in res.conditionalMenu){
                        let item = res.conditionalMenu[i];
                        for(let j in item.buttons){
                            res.conditionalMenu[i].buttons[j].radioIndex = num;
                            num++;
                        }
                    }
                    if (res) {
                        this.menuData = res.conditionalMenu;
                        console.log(res)
                        this.initTableData();
                        if(this.dialogType === 'add'){
                            this.radioValue = "";
                        }

                        // console.log(this.menuData, "this.menuData")
                    }
                }).catch(res => {
                    this.loadingFlag = false;
                })
            },
            showDialog() {
                this.createMenuShow = true;
            },
            changeMenu(type, index = false, btnIndex = false) {
                this.dialogType = type;
                //添加父菜单时超过3个的判断
                if (type == 'add') {
                    this.dialogTitle = "添加菜单";
                    this.initForm();
                    for(let i in this.menuData){
                        if(this.menuData[i].rule.tagId === this.tagId){
                            if(this.tagId == '66' && this.menuData[i].buttons.length === 3){
                                this.$message({
                                    message: "一级菜单不能超过3个",
                                    type: "warning"
                                });
                                return false;
                            }

                        }
                    }
                    // console.log(index, "index")

                }
                let typeObj = {
                    "click": 1,
                    "view": 2,
                    "miniprogram": 3,
                }
                //编辑父菜单时,载入数据
                if (type == 'edit') {
                    this.dialogTitle = "编辑菜单";
                    let item = this.menuData[index];
                    if(item.rule.language === 'zh_CN'){
                        this.isEn = false;
                    } else {
                        this.isEn = true;
                    }
                    this.parentIndex = index;
                    this.parentBtnIndex = btnIndex;
                    console.log(item.buttons[btnIndex], "1111");
                    let url = item.buttons[btnIndex].url;
                    //跳转小程序的时候,参数不一样
                    if(item.buttons[btnIndex].type === 3){
                        url = item.buttons[btnIndex].pagePath;
                    }
                    this.form.menuName = item.buttons[btnIndex].name;
                    if(item.buttons[btnIndex].type === "click" || item.buttons[btnIndex].type === "media_id" ){
                        this.loadingFlag = true;
                        let data = {mediaId: ""};

                        if(item.buttons[btnIndex].type === "click"){
                            data.mediaId = item.buttons[btnIndex].key
                        } else {
                            data.mediaId = item.buttons[btnIndex].mediaId
                        }
                        this.ccRequest.do("wechat/mp/wxMpMessage/getByMediaId", data, "GET").then(res => {
                            this.rowId = res.id;
                            this.form.menuType = 1;
                            this.activeName = res.msgtype;
                            // this.form.menuName = item.buttons[btnIndex].name;
                            if(item.buttons[btnIndex].type === "click"){
                                this.form.sendText = res.name;
                            } else {
                                this.showMediaId = data.mediaId;

                            }
                            this.loadingFlag = false;
                            this.showDialog();
                        }).catch(res => {
                            this.loadingFlag = false;
                        })
                        return false;

                    } else {
                        this.form.menuType = typeObj[item.buttons[btnIndex].type || 1];
                        this.form.sendMsg = url;
                    }

                }

                if(type == 'add-child'){
                    this.initForm()
                    if(typeof this.radioValue !== "number"){
                        this.$message({
                            message: "请先选择菜单",
                            type: "warning"
                        });
                        return false;
                    }
                    this.dialogTitle = "添加二级菜单";
                    this.parentIndex = index;
                    if (this.menuData[index] && this.menuData[index].subButtons.length >= 5) {
                        this.$message({
                            message: "子菜单不能超过5个",
                            type: "warning"
                        });
                        return false;
                    }
                }

                if(type == 'edit-child'){
                    this.dialogTitle = "编辑二级菜单";
                    let childItem = {};
                    for(let i in this.menuData){
                        if(this.menuData[i].rule.tagId === this.tagId){
                            for(let j in this.menuData[i].buttons){
                                if(this.menuData[i].buttons[j].radioIndex === this.radioValue){
                                    childItem = this.menuData[i].buttons[j].subButtons[this.childIndex];
                                }
                            }
                        }
                    }
                    let url = childItem.url;
                    console.log(childItem, "childItem");
                    if(childItem.type === "miniprogram"){
                        url = childItem.pagePath;
                    }
                    this.form.menuName = childItem.name;
                    this.form.menuType = typeObj[childItem.type];
                    if(childItem.type === 'click' || childItem.type === 'media_id'){
                        this.loadingFlag = true;
                        let data = {mediaId: ""};

                        if(childItem.type === "click"){
                            data.mediaId = childItem.key
                        } else {
                            data.mediaId = childItem.mediaId
                        }
                        this.ccRequest.do("wechat/mp/wxMpMessage/getByMediaId", data, "GET").then(res => {
                            this.rowId = res.id;
                            this.form.menuType = 1;
                            this.activeName = res.msgtype;
                            // this.form.menuName = item.buttons[btnIndex].name;
                            if(childItem.type === "click"){
                                this.form.sendText = res.name;
                            } else {
                                this.showMediaId = data.mediaId;
                            }
                            this.loadingFlag = false;
                            this.showDialog();
                        }).catch(res => {
                            this.loadingFlag = false;
                        })
                        return false;
                    }
                    this.form.sendMsg = url;
                    console.log(this.form)
                }
                this.showDialog()
            },
            //删除菜单
            delMenu(index, parentBtnIndex, isChild = false){
                let delParent = false;
                let confirmText = "此操作将删除该菜单";
                if(this.tagId == '66' ){
                    this.parentIndex = index;
                    if(this.menuData[index].buttons.length === 1){
                        this.$message({
                            type: "error",
                            message: "删除失败, 一级菜单必须有1条以上"
                        });
                        return false;
                    } else {
                        if(isChild){
                            if(this.menuData[index].buttons[parentBtnIndex].subButtons.length === 1){
                                confirmText = "此操作将级联删除一级菜单"
                                delParent = true;
                                // this.menuData[index].buttons.splice(parentBtnIndex, 1)
                            }
                        }
                    }
                } else {
                    this.parentIndex = index;
                    if(isChild && this.menuData[index].buttons[parentBtnIndex].subButtons.length == 1){
                        confirmText = "此操作将级联删除一级菜单";
                        delParent = true;
                    }
                }

                this.$confirm(`${confirmText}`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    console.log(this.parentIndex,this.parentBtnIndex, this.childIndex, "222222222")
                    this.loadingFlag = true;
                    if(isChild){
                        this.menuData[this.parentIndex].buttons[this.parentBtnIndex].subButtons.splice(this.childIndex, 1);
                    } else {
                        this.menuData[index].buttons.splice(parentBtnIndex, 1);
                    }
                    console.log(this.menuData[index], "askldjaskldjlk")
                    if((this.menuData[index].buttons.length === 0 || delParent) && this.tagId != '66'){
                        return this.ccRequest.do(`wechat/mp/fosberMp/menu/delete/${this.menuData[index].menuId}`, {}, "GET").then(res => {
                            this.getMenu();
                            this.$message({
                                message: "操作成功",
                                type: "success"
                            });
                        })
                    }
                    if(this.tagId == '66' && delParent){
                        this.menuData[index].buttons.splice(parentBtnIndex, 1);
                    }
                    this.postMenu();
                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });
                });
            },
            //子菜单初始化
            initTableData(){
                let data = {};
                for(let i in this.menuData){
                    if(this.menuData[i].rule.tagId === this.tagId){
                        for(let j in this.menuData[i].buttons){
                            if(this.menuData[i].buttons[j].radioIndex === this.radioValue){
                                data = this.menuData[i].buttons[j];
                            }
                        }
                    }
                }
                this.menuChildData = [];
                if(data.subButtons && data.subButtons.length>0){
                    let typeObj = {
                        "click": "发送消息",
                        "media_id": "发送消息",
                        "view": "跳转链接",
                        "miniprogram": "跳转小程序",
                    }
                    for(let i in data.subButtons){
                        let item = data.subButtons[i];
                        this.menuChildData.push({
                            sort: i/1+1,
                            name: item.name,
                            content: typeObj[item.type]
                        })
                    }
                }
                this.loadingFlag = false;
            },
            randomString(len) {
                len = len || 16;
                var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
                var maxPos = $chars.length;
                var pwd = '';
                for (let i = 0; i < len; i++) {
                    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
                }
                return pwd;
            },
            save() {
                if(this.loadingFlag){
                    return false;
                }
                // this.loadingFlag = true;
                let formData = this.form;
                let type = {
                    1: "click",
                    2: "view",
                    3: "miniprogram",
                }
                let newData = {
                    appId: null,
                    mediaId: null,
                    name: formData.menuName,
                    pagePath: null,
                    subButtons: [],
                    type: type[formData.menuType],
                    url: formData.sendMsg
                }
                if(formData.menuType === 1){
                    let rowData = {
                        msgtype: this.activeName,
                        type: 2,
                    }
                    if(this.activeName === 'text'){
                        let str = this.randomString();
                        newData.key = str;

                        rowData.mediaid = str;
                        rowData.name = formData.sendText;
                        if(rowData.name.length > 600 ){
                            return this.$message({
                                type: "warning",
                                message: "字数超过600字"
                            })
                        }
                    } else {
                        let row = this.mediaTableData[this.mediaTableConfig.radioValue];
                        newData.mediaId = row.mediaId;
                        rowData.mediaid = row.mediaId;

                        //这里因为是 图文 类型，返回的数据结构不一样
                        if(this.activeName === 'news'){
                            rowData.name = row.content.articles[0].title;
                            rowData.url = row.content.articles[0].thumbUrl;
                        } else {
                            rowData.name = row.name;
                            rowData.url = row.url;
                            rowData.content = row.url;
                        }
                        newData.type = "media_id";
                        console.log(row, this.activeName, this.mediaTableConfig.radioValue);
                    }
                    this.rowData = rowData;

                }
                if(formData.menuType == 3){
                    newData.appId = "wxbe7cd304b644d5bf";
                    newData.pagePath = newData.url;
                    newData.url = "https://www.baidu.com"
                }
                if(this.dialogType == 'add-child' || this.dialogType == 'edit-child'){
                    // if(this.childIndex!==false){
                        for(let i in this.menuData){
                            if(this.menuData[i].rule.tagId === this.tagId){
                                for(let j in this.menuData[i].buttons){
                                    // console.log(this.menuData[i].buttons[j].radioIndex)
                                    console.log(111111)
                                    if(this.menuData[i].buttons[j].radioIndex === this.radioValue){
                                        this.parentIndex = i;
                                        this.parentBtnIndex = j;
                                        if(this.menuData[i].buttons[j].subButtons == '' || this.dialogType == 'add-child'){
                                            this.menuData[i].buttons[j].subButtons.push(newData)
                                        } else {
                                            this.menuData[i].buttons[j].subButtons.splice(this.childIndex, 1, newData)
                                        }
                                    }
                                }
                            }
                        }
                    this.initTableData();
                } else if(this.dialogType == 'edit'){
                    if(this.parentIndex!==false){
                        // this.menuData[this.parentIndex].buttons.splice(this.parentBtnIndex, 1);
                        this.menuData[this.parentIndex].buttons.splice(this.parentBtnIndex, 1, newData);
                    }
                } else if(this.dialogType == 'edit-child') {

                }else {
                    let lang = this.isEn ? "en" : "zh_CN";
                    let isCreate = true;
                    for(let i in this.menuData){
                        if(this.menuData[i].rule.tagId == this.tagId){
                            console.log(this.menuData[i],i, lang, "index");
                            if(this.menuData[i].rule.language === lang){
                                isCreate = false;
                                this.parentIndex = i;
                                this.menuData[i].buttons.push(newData);
                                // console.log(this.menuData[i], newData, "buttons")
                            }
                            if(this.tagId === '66'){
                                this.parentIndex = i;
                                this.menuData[i].buttons.push(newData);
                            }

                        }
                    }
                    if(isCreate === true){
                        if(this.tagId != '66'){
                            this.menuData.unshift({
                                buttons: [{
                                    ...newData
                                }],
                                rule: {
                                    language: lang,
                                    tagId: this.tagId,
                                }
                            })
                            this.parentIndex = 0;
                            console.log(111111111);
                        }else{

                        }

                    }

                }
                // console.log(this.menuData[this.parentIndex], "this.menuData[i].buttons");
                this.postMenu();


            },

            postMenu() {
                this.loadingFlag = true;
                let postButtons = [];
                let menuId = "";
                let nowLanguage = this.isEn ? 'en' : "zh_CN";
                console.log(this.menuData, this.parentIndex);
                if(this.parentIndex !== false && this.parentIndex > -1){
                    let nowItem = this.menuData[this.parentIndex];
                    postButtons = nowItem.buttons;
                    nowLanguage = nowItem.rule.language;
                    menuId = nowItem.menuId;
                }
                console.log(this.menuData[this.parentIndex], this.parentIndex, "postButtons");
                let data = {
                    buttons: postButtons,
                    menuId:menuId,
                    matchRule: {
                        language: nowLanguage,
                        tagId: this.tagId
                    }
                }
                if(this.tagId == '66'){
                    delete data.matchRule;
                    delete data.menuId;
                }
                let localData = this.rowData;
                if(this.rowId){
                    localData.id = this.rowId;
                }
                console.log(localData, "localData");
                this.ccRequest.do("wechat/mp/wxMpMessage/fosberMp/save", localData, "POSTJSON").then(res => {
                    this.ccRequest.do("wechat/mp/fosberMp/menu/create", data, "POSTJSON").then(res => {
                        this.parentIndex = false;
                        this.childIndex = false;
                        this.createMenuShow = false;
                        this.initForm()
                        this.getMenu()
                        this.$message({
                            message: "操作成功",
                            type: "success"
                        });
                    }).catch(res => {
                        this.getMenu()
                        this.$message({
                            type: "error",
                            message: res.response.data.message
                        })
                    })
                })


            },
            initForm(){
                this.form.menuName = "";
                this.form.sendMsg = "";
                this.form.menuType = 1;
                this.form.sendText = "";
                this.mediaTableConfig.radioValue = 0;
                this.activeName = "text";
                this.rowId = false;
                this.isEn = false;
            }
        },
        mounted() {
            this.getMenu();
        }
    }
</script>
<style lang="scss">
    .form-tabs{
        .el-tabs__nav{
            .el-tabs__item{
                height: 20px;
                line-height: 20px;
                font-size: 14px !important;
                font-weight: 0 !important;
            }

        }
    }
</style>
<style scoped lang="scss">
    .wehcat-menu {

        .left, .right {
            background: #ffffff;
            padding: 20px;
            min-height: 80vh;
        }

        .left {
            .el-radio-group {
                width: 100%;
            }

            .radio-group {
                margin-top: 15px;

            }

            .radio-control {
                margin-top: 15px;
            }

            .btn-group {
                max-width: 80px;
            }
        }
        .right{
            .add-child{
                margin-bottom: 30px;
            }
        }

        .save {
            margin-top: 20px;
            justify-content: center;
        }
    }
</style>
